import type { SVGProps } from 'react'
const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="key_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#key_svg__a)">
      <path d="M5.25 10.567q-.646 0-1.106-.46A1.5 1.5 0 0 1 3.683 9q0-.646.46-1.106.462-.461 1.107-.461.646 0 1.106.46.461.462.461 1.107 0 .646-.46 1.107-.462.46-1.107.46m0 3.072q-1.928 0-3.284-1.355T.611 9t1.355-3.284T5.25 4.361q1.305 0 2.361.646 1.056.645 1.656 1.676h6.577L18.166 9l-3.47 3.47-1.504-1.135-1.495 1.12-1.616-1.138h-.814a4.7 4.7 0 0 1-1.654 1.674 4.43 4.43 0 0 1-2.363.648m0-1.639q1.068 0 1.87-.65.8-.652 1.05-1.667h2.42l1.065.75 1.537-1.143 1.327 1.022 1.335-1.294-.697-.7H8.165a2.96 2.96 0 0 0-1.044-1.66A2.88 2.88 0 0 0 5.25 6q-1.237 0-2.119.881A2.9 2.9 0 0 0 2.25 9q0 1.237.881 2.119A2.9 2.9 0 0 0 5.25 12" />
    </g>
  </svg>
)
export default SvgKey
